export const blueConfig = {
    serviceUUID: "12345699-1234-1234-1234-123456789abc",
    characteristicUUID: "87654321-4321-4321-4321-cba987654399",
}
